import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import BasicChip from "./BasicChip/BasicChip";

const ChipPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox
        title={"Chip"}
        description={
          "Chips are compact elements that represent an input, attribute, or action."
        }
      />
      <Divider light />
      <BasicChip />
    </Paper>
  );
};

export default ChipPage;
